<template>
    <div class="container-fluid">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                <div v-if="(id > 0)" class="col-sm-6">
                    <h1>{{ $t('general.cliente') }}</h1>
                </div>
                <div v-else class="col-sm-6">
                    <h1>{{ $t('general.nuevocliente') }}</h1>
                </div>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="row">
                <!-- Ocultar esta columna en la creación -->
                <div  v-if="(id > 0)" class="col-md-2">
                    <div class="card bg-gradient-primary">
                        <div class="card-body box-profile">
                            <h3 class="profile-username text-center">{{cliente.nombre}}</h3>
                            <p class="text-muted text-center text-white">{{cliente.razon_social}}</p>
                        </div>
                    </div>
                    <div class="card card-primary card-outline">
                        <div class="card-body box-profile">
                            <ul class="list-group list-group-unbordered mb-3">
                            <li class="list-group-item">
                                <b>{{ $t('general.servicios') }}</b> <a style="cursor:pointer" @click="abrirServicios($event)" class="float-right">{{ servicios.length }}</a>                                
                            </li>
                            <li class="list-group-item">
                                <b>{{ $t('general.serviciosactivos') }}</b> <a class="float-right" style="cursor:pointer" @click="abrirServiciosActivos($event)">{{ serivicios_activos.length }}</a>
                            </li>
                            </ul>
                            <OverlayPanel ref="act">
                                <!-- que el div tenga una altura de 100 px y con un scroll -->
                                <div style="display: grid; gap: 5px; max-height: 200px; overflow-y: auto">
                                    <!-- listar servicios de this.servicios, para que sea un link -->
                                    <a v-for="servicio in serivicios_activos" style="cursor:pointer; color: #007bff" :key="servicio.idservicios" @click="irServicio(servicio);abrirServiciosActivos($event)">{{ servicio.codigo }}</a>
                                </div>
                            </OverlayPanel>
                            <OverlayPanel ref="serv">
                                <div style="display: grid; gap: 5px; max-height: 200px; overflow-y: auto">
                                    <!-- listar servicios de this.servicios, para que sea un link -->
                                    <a v-for="servicio in servicios" style="cursor:pointer; color: #007bff" :key="servicio.idservicios" @click="irServicio(servicio);abrirServicios($event)">{{ servicio.codigo }}</a>
                                </div>
                            </OverlayPanel>
                        </div>
                    </div>
                    <div class="callout callout-info">
                    <h5>{{ $t('general.ultimamodificacion') }}</h5>
                    <p>{{cliente.fecha_actualiza_cliente}}</p>
                    </div>
                </div>
                <div class="col-md-10">
                    <div class="card card-default card-tabs">
                        <div class="card-header p-1 pt-1">
                            <ul class="nav nav-pills">
                                <li class="nav-item"><a class="nav-link active" href="#datos_cliente" data-toggle="tab">{{ $t('general.datos') }}</a></li>  
                            </ul>
                        </div>
                    </div>
                    <br>
                    <div class="tab-content">
                        <div class="active tab-pane" id="datos_cliente">
                            <div v-if="id>0">
                                <cliente-datos :cliente="cliente" :id="cliente.id"/>
                            </div>
                            <div v-else>
                                <cliente-datos :cliente="cliente" :id="id"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import OverlayPanel from 'primevue/overlaypanel';
import { PwgsApi } from '../../../services/PwgsApi';
import ClienteDatos from './datos/ClienteDatos.vue'
export default {
    props: ['id'],
    components: {
        'cliente-datos': ClienteDatos,
        OverlayPanel,
    },
    data() {
        return {
            servicios: [],
            serivicios_activos: [],
            cliente:[],
        }
    },
    methods: {
        abrirServicios(event) {
            console.log('abrirserv',this.$refs['serv'], event);
            this.$refs['serv'].toggle(event);
        },
        abrirServiciosActivos(event) {
            this.$refs['act'].toggle(event);
        },
        irServicio(servicio) {
            localStorage.setItem('nombreservicio' + servicio.idservicios, servicio.codigo);
            this.$router.push({
                name: 'Servicio',
                params: {
                    id: servicio.idservicios,
                    nombreservicio: servicio.codigo,
                }
            });
        },
        async obtenerCliente(id) {
            /* GET  modulos/pwgsapi/index.php/clientes/:id */
            const api = new PwgsApi();
            const datos = await api.get("clientes/" + id);
            this.cliente = datos.datos;
            let ventana = '';
            let ventanaid = this.$props.id.toString();
            let ventanas = this.$store.getters.ventanas;
            let nombrecliente = this.cliente.nombre;
            for (let i = 0; i < ventanas.length; i++) {
                ventana = this.$store.getters.ventanas[i].path;
                if (ventana=='/clientes/'+ventanaid) {
                    if(this.id){
                        this.$store.getters.ventanas[i].name = nombrecliente;
                        this.$store.getters.ventanas[i].alt = "Cliente: " + this.cliente.nombre + " || " + this.cliente.direccion;
                    }else{
                        this.$store.getters.ventanas[i].name = "Crear cliente";
                        this.$store.getters.ventanas[i].alt = "Crear cliente";
                    }
                }
            }
            this.servicios = this.cliente[0].servicios;
            this.serivicios_activos = this.servicios.filter(servicio => servicio.estado != 'eliminado' && servicio.estado != 'finalizado');
        },
    },
    mounted() {
        this.obtenerCliente(this.id);
    },
    watch: {
        id() {
            this.obtenerCliente(this.id);
        },   
    }

    
}
</script>